module.exports = __webpack_public_path__ + "img/img.0488c6d6.png";